import * as React from 'react'
import styled from 'styled-components'
import { DatItem } from './DatItem'
import { DatLabelText } from './DatLabelText'

type Props = {
  label: React.ReactNode
  items: string[]
  activeItemIndex: number
  onChange: (selectedIndex: number) => void
}

const DatItemSelect = styled(DatItem)`
  --dat-accent: rgba(148, 163, 184, 0.42);
`

const SelectWrap = styled.div`
  position: relative;
  flex: 1 1 62%;
  min-width: 0;

  @media (max-width: 520px) {
    flex-basis: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 12px;
    width: 7px;
    height: 7px;
    border-right: 1.5px solid rgba(226, 232, 240, 0.72);
    border-bottom: 1.5px solid rgba(226, 232, 240, 0.72);
    transform: translateY(-65%) rotate(45deg);
    pointer-events: none;
  }
`

const SelectField = styled.select`
  width: 100%;
  min-width: 0;
  min-height: 34px;
  padding: 0 34px 0 10px;
  color: #e2e8f0;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 11px;
  background: rgba(2, 6, 23, 0.46);
  appearance: none;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;

  &:hover {
    background: rgba(2, 6, 23, 0.58);
    border-color: rgba(148, 163, 184, 0.18);
  }

  &:focus-visible {
    outline: none;
    border-color: rgba(147, 197, 253, 0.24);
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.08);
  }
`

export const DatSelect = (props: Props) => {
  const ariaLabel = typeof props.label === 'string' ? props.label : 'Select field'

  return (
    <DatItemSelect>
      <DatLabelText>{props.label}</DatLabelText>

      <SelectWrap>
        <SelectField
          aria-label={ariaLabel}
          value={props.activeItemIndex}
          onChange={event => props.onChange(Number.parseInt(event.target.value, 10))}
        >
          {props.items.map((item, i) => (
            <option key={i} value={i}>
              {item}
            </option>
          ))}
        </SelectField>
      </SelectWrap>
    </DatItemSelect>
  )
}
